import React from "react";
import { useSelector } from "react-redux";
import pathRouts from "../../../../shared/enums/pathRoute";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import finalProjectsWidgetImg from "../../../../assests/finalProjects/finalProjectsWidgetImg.svg";
import classes from "./FinalProjectsWidget.module.css";
import Widget from "../../../../shared/components/features/widget/Widget";

const FinalProjectsWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <Widget
            color="#B5267E"
            mainLink={`/${pathRouts.FINALPROJECTS}`}
            title={texts.finalProjects}
            icon={iconsList.finalProgectWidgetIcon}
            titleColor={"#fff"}
            className={classes.FinalProjectsWidget}
        >
            <div className={classes.FinalProjectsContent}>
                <img
                    src={finalProjectsWidgetImg}
                    alt={texts.finalProjects}
                    className={classes.FinalProjectsImg}
                />
                <div className={classes.FinalProjectsText}>
                    <span className={classes.NewText}>{texts.new}! </span>{texts.finalProjectsText}
                </div>
            </div>
        </Widget>
    );
};

export default FinalProjectsWidget;